"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextCoreError = void 0;
class ContextCoreError extends Error {
    constructor(message, cause) {
        super(message);
        this.name = 'ContextCoreError';
        this.cause = cause;
        this.message = `${this.message}\n${this.cause ? `\nCaused By: ${this.cause}` : ''}\n`;
    }
    toString() {
        return `[${this.name}] ${this.message}`;
    }
}
exports.ContextCoreError = ContextCoreError;
